import { Component, OnInit } from '@angular/core';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
 
@Component({
  selector: 'app-complaint-master',
  templateUrl: './complaint-master.component.html',
  styleUrls: ['./complaint-master.component.scss']
})
export class ComplaintMasterComponent implements OnInit {
 
  formData = {
    category: '',
    complaint: ''
  };
 
  activeField: string = '';
 
  constructor(public voiceService: VoiceRecognitionService) {}
  ngOnInit(): void {
    this.voiceService.init();
 
    this.voiceService.recognition?.addEventListener('result', (e: any) => {
      const transcript = Array.from(e.results)
        .map((result: any) => result[0])
        .map((result: any) => result.transcript)
        .join('')
        .trim()
        .toLowerCase();
 
      // Handle "gotonext"
      if (transcript === 'next') {
        this.goToNextField();
        return;
      }
 
      if (this.activeField && transcript) {
        this.formData[this.activeField] = this.formData[this.activeField]
          ? this.formData[this.activeField] + ' ' + transcript
          : transcript;
      }
    });
  }
  activateVoice(field: string) {
    this.activeField = field;
    this.voiceService.start(field); // You can simplify this to just one `start()` method if you like
  }
 
  stopVoice() {
    this.voiceService.stop(this.activeField);
  }
 
  goToNextField() {
    if (this.activeField === 'category') {
      this.activeField = 'complaint';
      const el = document.querySelector<HTMLInputElement>('input[name="complaint"]');
      el?.focus();
    } else if (this.activeField === 'complaint') {
      this.activeField = ''; // Or loop back / go to the next logical field
    }
  }
 
 
  opencompliantModal(){
    document.getElementById("compliantModal").style.display='block';
  }
 
  closecompliantModal(){
    document.getElementById("compliantModal").style.display='none';
  }
 
}